import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        color: "grey",
        variant: "text",
        to: "/mail/inbox"
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
          _createTextVNode(" Back to List ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isDraft)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "Edit Draft"))
        : (_openBlock(), _createElementBlock("h2", _hoisted_5, "New Message")),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.templateDialog = true)),
        disabled: _ctx.loading,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
          _createTextVNode("Template", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_v_form, {
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.valid) = $event)),
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "pt-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.title,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                      rules: [_ctx.required],
                      disabled: _ctx.loading,
                      label: "Title",
                      variant: "filled"
                    }, null, 8, ["modelValue", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                  modelValue: _ctx.targetVariant,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetVariant) = $event)),
                  inline: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Broadcast to Class/Group",
                      value: "group",
                      disabled: _ctx.loading
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_v_radio, {
                      label: "Select children to broadcast",
                      disabled: _ctx.loading,
                      value: "children"
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('common.fiscalYear')), 1),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.year,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.year) = $event)),
                      items: _ctx.yearList,
                      disabled: _ctx.loading,
                      variant: "outlined"
                    }, null, 8, ["modelValue", "items", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.targetVariant === 'group')
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.classIds,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.classIds) = $event)),
                          items: _ctx.classList,
                          "item-title": "className",
                          "item-value": "classId",
                          disabled: _ctx.loading,
                          multiple: "",
                          label: "To (Class)",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "items", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.groupIds,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.groupIds) = $event)),
                          items: _ctx.groups,
                          "item-title": "name",
                          "item-value": "groupId",
                          disabled: _ctx.loading,
                          multiple: "",
                          label: "To (Group)",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "items", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.targetVariant === 'children')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "mt-8 mb-4" }, "Select Children", -1)),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.childrenSelectionClassIds,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.childrenSelectionClassIds) = $event)),
                            items: _ctx.classList,
                            "item-title": "className",
                            "item-value": "classId",
                            disabled: _ctx.loading,
                            multiple: "",
                            label: "Add children from class",
                            variant: "outlined"
                          }, null, 8, ["modelValue", "items", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.childrenSelectionGroupIds,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.childrenSelectionGroupIds) = $event)),
                            items: _ctx.groups,
                            "item-title": "name",
                            "item-value": "groupId",
                            disabled: _ctx.loading,
                            multiple: "",
                            label: "Add children from group",
                            variant: "outlined"
                          }, null, 8, ["modelValue", "items", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    (_ctx.isFetchingChildren)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "primary",
                          class: "my-8"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _cache[16] || (_cache[16] = _createElementVNode("h5", null, "Select Individually", -1)),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenOptions, (child) => {
                              return (_openBlock(), _createBlock(_component_v_card, {
                                variant: "outlined",
                                class: "pa-2 mb-2",
                                key: child.classId
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", null, _toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName), 1),
                                    _createVNode(_component_v_spacer),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_v_btn, {
                                        disabled: _ctx.loading,
                                        variant: "outlined",
                                        size: "small",
                                        color: "primary",
                                        onClick: ($event: any) => (_ctx.selectChild(child))
                                      }, {
                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                          _createTextVNode("Select", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _cache[18] || (_cache[18] = _createElementVNode("h5", null, "Selected Children", -1)),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChildren, (child) => {
                              return (_openBlock(), _createBlock(_component_v_card, {
                                variant: "outlined",
                                class: "pa-2 mb-2",
                                key: child.classId
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", null, _toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName), 1),
                                    _createVNode(_component_v_spacer),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_v_btn, {
                                        variant: "outlined",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.removeChild(child)),
                                        disabled: _ctx.loading
                                      }, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                          _createTextVNode("Deselect", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick", "disabled"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider, { class: "my-8" }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.body,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.body) = $event)),
                      rules: [_ctx.required],
                      disabled: _ctx.loading,
                      label: "Message Body",
                      height: "30vh",
                      variant: "filled"
                    }, null, 8, ["modelValue", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_file_input, {
                      modelValue: _ctx.file,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.file) = $event)),
                      label: "Select files (multiple allowed)",
                      suffix: "PDF/Images",
                      disabled: _ctx.loading,
                      multiple: "",
                      variant: "outlined",
                      accept: "application/pdf, image/png, image/jpeg, image/jpg"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachmentUrlsDraft, (item, i) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: "12",
                            key: i,
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                src: _ctx.attachmentUrlsDraft[i]
                              }, null, 8, ["src"]),
                              _createVNode(_component_v_btn, {
                                href: item,
                                target: "_blank",
                                color: "primary",
                                variant: "outlined",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(`Attachment ${Number(i)+1}`), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"]),
                              _cache[21] || (_cache[21] = _createTextVNode("  ", -1)),
                              _createVNode(_component_v_btn, {
                                onClick: ($event: any) => (_ctx.deleteDownloadUrl(i)),
                                color: "primary",
                                variant: "flat",
                                size: "small"
                              }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode(_toDisplayString(`Delete`), -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.deleteChat,
                      loading: _ctx.loading,
                      color: "red",
                      dark: "",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.saveAsTemplate,
                      loading: _ctx.loading,
                      disabled: !_ctx.valid,
                      color: "blue-grey",
                      variant: "outlined",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("Save as Template ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.saveAsDraft,
                      loading: _ctx.loading,
                      disabled: !_ctx.valid,
                      color: "blue-grey",
                      class: "white--text",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode(" Save Draft ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.send,
                      disabled: !_ctx.valid,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode(" Send ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.templateDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.templateDialog) = $event)),
      "max-width": "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("Templates", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, null, {
                      default: _withCtx(() => [
                        _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Title"),
                            _createElementVNode("th", null, "Body"),
                            _createElementVNode("th"),
                            _createElementVNode("th")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (item, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(item.title), 1),
                              _createElementVNode("td", null, _toDisplayString(item.body), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.applyTemplate(item.templateId)),
                                  color: "primary",
                                  variant: "flat",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                    _createTextVNode("Apply", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.deleteTemplate(item.templateId)),
                                  color: "error",
                                  variant: "outlined",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.templateDialog = false)),
                          color: "grey",
                          variant: "text"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}